import { gql } from "@apollo/client";

// Proof of attendance for one duty (duty modal) - the same view the customer
// portal shows. source: 'schedule' | 'mobileService'. Staff tokens only; tenant
// comes from the session. response: { siteName, row, events[], mapAttribution }.
export const getDutyProofQuery = gql`
query($source: String!, $id: String!){
  getDutyProof(source: $source, id: $id) {
    message
    response
  }
}
`;
